import React from 'react'
import Addcourse from '../../Components/tutor/Addcourse'


function Course() {
  return (
    <div>
      <Addcourse/>
    </div>
  )
}

export default Course
